{
  "salon-search-form-advance-dialog": {
    "buttons": {
      "cancel": "Abbrechen",
      "save": "Speichern"
    },
    "text": {
      "title": "Vorlauffilter",
      "kilometer": "Kilometer",
      "only-salon-with-discount": "Nur mit Rabatt",
      "only-salon-with-discount-description": "Nur Salon mit ermäßigten Dienstleistungen anzeigen",
      "radius": "Radius",
      "radius-description": "Wie weit die Salons vom gewünschten Standort entfernt sein sollen",
      "sort-by": "Sortieren nach",
      "sort-by-distance": "Entfernung",
      "sort-by-distance-description": "Der Salon in der Nähe des gewünschten Standorts wird zuerst angezeigt",
      "sort-by-rating": "Bewertung",
      "sort-by-rating-description": "Der Salon mit der besten Bewertung wird zuerst angezeigt"
    }
  }
}
